import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import dayjs from 'dayjs';
import {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {TSlot} from '../../../../../redux/timetable/timetable.type';
import DisabledInput from '../../../../../component/input/disabledInput/DisabledInput';

const formatTime = (timeStart: number) => dayjs.unix(timeStart).format('HH:mm');

interface TimeSlotFieldProps {
    show: TShow;
}

const TimeSlotField: FC<TimeSlotFieldProps> = ({show}) => {
    const {t} = useTranslation('timetable');
    const [field, meta] = useField<number | null>('tsid');
    const slots = useSelector((state: RootState) => state.timetable.slots);

    const selected = slots.find((s: TSlot) => s.tsid === field.value);

    const toggle = () => { if (show.isOpen) show.close(); else show.open(); };

    return (
        <DisabledInput
            text={t('timeSlot')}
            icon="hourglassOutline"
            value={selected ? formatTime(selected.timeStart) : ''}
            events={{onClick: toggle}}
            className=""
            children={undefined}
            dataCyName=""
            hasArrow
            invalid={!!(meta.touched && meta.error)}
        />
    );
};

export default TimeSlotField;
